<template>
    <div>
      <div 
        @click="launchFile()">
        <slot name="activator"></slot>
      </div>
  
      <input 
        type="file"
        accept="image/png, image/gif, image/jpg, image/jpeg"
        ref="file"
        :name="filename"
        v-on:change="changeImage($event.target.files)"
        style="display:none">
  
      <v-dialog 
        v-model="dialog"
        width="500">
        <v-card
          flat>
          <v-card
            color="red accent-2">
            <v-list-item>
              <v-list-item-avatar 
                color="red accent-2" 
                size="30">
                <v-icon 
                  large 
                  color="white">
                  mdi-alert
                </v-icon>
              </v-list-item-avatar>
              
              <v-list-item-content>
                <div
                  class="caption white--text">
                  {{ message.error }}
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
    export default {
      name: 'upload-folder',
      data: () => ({
        dialog: false,
        filename: 'file',
        message: {
          success: '',
          error: ''
        },
        process: {
          file: false
        }
      }),
      methods: {
        launchFile () {
          this.$refs.file.click()
        },
        changeImage (file) {
          let image = file[0]
  
          if (file.length > 0) {
            if (image.type != 'image/jpg' && image.type != 'image/jpeg' && image.type != 'image/png') {
              this.dialog = true
              this.message.error = 'Silahkan pilih gambar dengan format .jpg / .jpeg / .png'
            } else if (image.size > 5242880) {
              this.dialog = true
              this.message.error = 'Maksimal gambar 5MB'
            } else {

                const blob = URL.createObjectURL(file[0]);

                // 3. Update the image. The type will be derived from the extension and it can lead to an incorrect result:
                // this.image = {
                // src: blob,
                // type: file[0].type,
                // };
  
              this.$emit('input', {
                  filename: image.name,
                  // filepath: image.file_path,
                  fileuri: blob,
                  filesize: image.size,
                  filemime:  file[0].type,
                  file: image
                })
              // let formData = new FormData()
              //     formData.append('api-key', 'd3f8bfb9d73c9ced96c369186ea2743e')
              //     formData.append('client-key', 'apikdce584a2be25dd8ae3cc403c3532')
              //     formData.append('files[]', document)
              //     formData.append('user_id', this.$store.state.user.id)
  
              // this.process.form = true
  
              // this.$emit('input', {
              //   process: this.process.form
              // })
  
              // fetch(`${process.env.VUE_APP_API_CDN}document`, {
              //   method: 'POST',
              //   body: formData
              // })
              // .then(res => res.json())
              // .then(response => {
              //   this.process.form = false
  
              //   this.$emit('input', {
              //     filename: response.data[0].data.file_name,
              //     // filepath: response.data[0].data.file_path,
              //     fileuri: response.data[0].data.file_url,
              //     filesize: document.size,
              //     filemime: document.type,
              //     process : this.process.form
              //   })
              // })
            }
          }
        }
      }
    }
  </script>